import { useNavigate } from 'react-router'
import { useUserPreferences } from '@/src/hooks/use-user-preference-port/useUserPreferencePort'
import { userPreferencesPort } from '@/infra/config/beans'
import { useQuery } from '@tanstack/react-query'
import FamilyCard from '@/src/components/global/family-card/FamilyCard'
import { t } from 'i18next'
import FamilyCardListSkeleton from '@/src/components/global/family-card-list-skeleton/FamilyCardListSkeleton'
import { trackEvent } from '@/src/analytics/amplitude'
import { getActionPlans } from '@/infra/api/generated/action-plans/action-plans'

const { getInProgressActionPlans } = getActionPlans()

const Index = () => {
  const navigate = useNavigate()
  const { store, team } = useUserPreferences(userPreferencesPort)
  const { data: actionPlans, isFetching } = useQuery({
    queryKey: ['actions', 'in-progress', store?.id, team?.id],
    enabled: Boolean(store) && Boolean(team),
    queryFn: () => getInProgressActionPlans(store!.id, team!.id),
  })

  if (actionPlans?.length === 0) {
    return (
      <div className="w-full flex flex-col justify-center items-center text-center gap-2">
        <span className="font-semibold">{t('pages.home.no-actions.title')}</span>
        <span className="text-content-quiet">{t('pages.home.no-actions.subtitle')}</span>
      </div>
    )
  }

  const handleFamilyCardButtonClick = (diagnosisId: string) => {
    trackEvent('CONTINUE_ACTION_PLAN_BUTTON_CLICK', { diagnosisId, source: 'my-hub' })
    void navigate(`/diagnoses/${diagnosisId}/actions`, {
      viewTransition: true,
      state: { source: 'actions' },
    })
  }

  return (
    <div className="w-full flex flex-col gap-3">
      {isFetching && <FamilyCardListSkeleton skeletonCount={2} />}
      {!isFetching &&
        actionPlans?.map((plan) => (
          <FamilyCard
            data-testid="action-plan-in-progress-family-card"
            key={plan.actionPlanId}
            family={plan.family}
            score={plan.completionPercentage}
            date={plan.startedAt}
            buttonProps={{
              label: t('pages.home.see-actions', {
                countActions: plan.countActionsToDo,
                count: plan.countActionsToDo,
              }),
              onClick: () => handleFamilyCardButtonClick(plan.diagnosisId),
            }}
          />
        ))}
    </div>
  )
}

export default Index
